module.exports = __webpack_public_path__ + "img/pdf_big.e274ed9a.png";